import { useEffect, useRef } from 'react';

/**
 * Calls `onVisible` whenever it comes within `rootMargin` of the viewport.
 * The observer is recreated with each new `onVisible`, and a fresh observer
 * reports straight away, so pages keep loading while the end stays in view.
 */
const InfiniteScrollTrigger = ({
  onVisible,
  rootMargin = '600px',
}: {
  onVisible: () => void;
  rootMargin?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;

    if (!el || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          onVisible();
        }
      },
      { rootMargin },
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [onVisible, rootMargin]);

  return <div ref={ref} aria-hidden className="h-px" />;
};

export default InfiniteScrollTrigger;
